import {SalesforceInstanceContext} from "../providers/context";
import {useContext} from "react";

export default function useSalesforceInstance() {
    return useContext(SalesforceInstanceContext)
}